import { render } from "./ServicesTaxi.vue?vue&type=template&id=18083e29&scoped=true"
import script from "./ServicesTaxi.vue?vue&type=script&lang=js"
export * from "./ServicesTaxi.vue?vue&type=script&lang=js"

import "./ServicesTaxi.vue?vue&type=style&index=0&id=18083e29&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18083e29"]])

export default __exports__